import { useBaseListView } from '@/common/view/useBaseListView';
import { useCrudActions } from '@/common/view/useCrudActions';
import { rfmService } from '@/services/rfm';
import { computed } from 'vue';

export function useRfmGroupList() {
    const crudAction = useCrudActions();
    const { list, total, fetchList: fetchRfmGroupAll } = useBaseListView({ request: rfmService.group.list });

    const rfmGroupNameMap = computed(() => new Map(list.value.map(({ id, name }) => [id, name] as [number, string])));
    const rfmGroupOptions = computed(() => list.value.map(({ id, name }) => ({ value: id, label: name })));

    const actions = {
        remove: crudAction.confirmAndRemove({
            request: rfmService.group.remove,
            onSuccess: () => fetchRfmGroupAll()
        })
    };

    return { list, total, fetchRfmGroupAll, rfmGroupOptions, rfmGroupNameMap, actions };
}
